import { useMemo } from 'react';
import { estimateStrength } from '@battini/crypto';

const COLORS = ['#f87171', '#f87171', '#fbbf24', '#34d399', '#34d399'];
const LABELS = ['Very weak', 'Weak', 'Fair', 'Strong', 'Very strong'];

export function PasswordStrength({ password }: { password: string }) {
  const { score, label } = useMemo(() => (password ? estimateStrength(password) : { score: 0, label: '' }), [password]);
  if (!password) return null;
  const width = ((score + 1) / 5) * 100;
  return (
    <div>
      <div className="meter"><span style={{ width: `${width}%`, background: COLORS[score] }} /></div>
      <div className="flex between" style={{ marginTop: 4 }}>
        <span className="muted" style={{ fontSize: 12 }}>{LABELS[score]}</span>
        <span className="muted" style={{ fontSize: 12 }}>{label}</span>
      </div>
    </div>
  );
}
